import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { cargoApi, type Driver } from '@/api/cargo';
import { PageHead, DataTable, Drawer, SectionCard, Field, StatusBadge, type Col } from '@/shared/ui/kit';
import { useToast } from '@/app/providers/ToastProvider';

const empty = { Code: '', Name: '', Phone: '', VehicleNo: '', IsActive: true };

export function DriversPage() {
  const toast = useToast();
  const [edit, setEdit] = useState<Driver | null | undefined>(undefined);
  const [form, setForm] = useState({ ...empty });
  const [busy, setBusy] = useState(false);
  const q = useQuery({ queryKey: ['cargo', 'drivers'], queryFn: cargoApi.drivers });

  function open(d: Driver | null) {
    setEdit(d);
    setForm(d ? { Code: d.Code, Name: d.Name, Phone: d.Phone, VehicleNo: d.VehicleNo ?? '', IsActive: d.IsActive } : { ...empty });
  }
  async function save() {
    if (!form.Code.trim() || !form.Name.trim() || !form.Phone.trim()) return toast('Код, нэр, утас оруулна уу.', 'warning');
    setBusy(true);
    try {
      await cargoApi.saveDriver(edit ? edit.Id : null, form);
      toast('Хадгаллаа.', 'success');
      setEdit(undefined);
      q.refetch();
    } catch (e) { toast((e as Error).message, 'danger'); } finally { setBusy(false); }
  }

  const cols: Col<Driver>[] = [
    { key: 'Code', label: 'Код', width: 110, render: (r) => <button className="ct-link" onClick={(e) => { e.stopPropagation(); open(r); }}>{r.Code}</button> },
    { key: 'Name', label: 'Нэр', render: (r) => r.Name },
    { key: 'Phone', label: 'Утас', render: (r) => r.Phone },
    { key: 'VehicleNo', label: 'Тээврийн хэрэгсэл', render: (r) => r.VehicleNo ?? '—' },
    { key: 'IsActive', label: 'Төлөв', render: (r) => <StatusBadge label={r.IsActive ? 'Идэвхтэй' : 'Идэвхгүй'} color={r.IsActive ? 'var(--ts-ok)' : 'var(--ts-muted)'} /> },
  ];

  return (
    <div>
      <PageHead title="Жолооч / Курьер" subtitle="Дотоодын хүргэлтийн жолооч нар."
        actions={<button className="ts-btn ts-btn-primary" onClick={() => open(null)}><i className="bi bi-plus-lg" /> Шинэ</button>} />
      <DataTable cols={cols} rows={q.data ?? []} onRowClick={open} empty="Жолооч алга." />
      {edit !== undefined && (
        <Drawer title={edit ? edit.Name : 'Шинэ жолооч'} open onClose={() => setEdit(undefined)}
          footer={<><button className="ts-btn ts-btn-ghost" onClick={() => setEdit(undefined)}>Болих</button><button className="ts-btn ts-btn-primary" disabled={busy} onClick={save}><i className="bi bi-check2" /> Хадгалах</button></>}>
          <SectionCard icon="bi-person-badge" title="Үндсэн мэдээлэл">
            <div className="ts-row">
              <div style={{ gridColumn: 'span 4' }}><Field label="Код" required><input className="ts-input" required value={form.Code} onChange={(e) => setForm({ ...form, Code: e.target.value })} /></Field></div>
              <div style={{ gridColumn: 'span 8' }}><Field label="Нэр" required><input className="ts-input" required value={form.Name} onChange={(e) => setForm({ ...form, Name: e.target.value })} /></Field></div>
              <div style={{ gridColumn: 'span 6' }}><Field label="Утас" required><input className="ts-input" required value={form.Phone} onChange={(e) => setForm({ ...form, Phone: e.target.value })} /></Field></div>
              <div style={{ gridColumn: 'span 6' }}><Field label="Тээврийн хэрэгслийн дугаар"><input className="ts-input" value={form.VehicleNo} onChange={(e) => setForm({ ...form, VehicleNo: e.target.value })} /></Field></div>
              <div style={{ gridColumn: 'span 12' }}><label className="ts-flex-row" style={{ cursor: 'pointer' }}><input type="checkbox" checked={form.IsActive} onChange={(e) => setForm({ ...form, IsActive: e.target.checked })} /> Идэвхтэй</label></div>
            </div>
          </SectionCard>
        </Drawer>
      )}
    </div>
  );
}
